import React, { useRef } from 'react';
import cx from 'classnames';
import SkeletonWrapper from './skeleton/SkeletonWrapper';

/**
 * @typedef {object} ReportTableProps
 * @property {*} [rows]
 * @property {*} [headers]
 * @property {boolean} [white]
 * @property {boolean} loading
 */

/**
 * @param {ReportTableProps} props
 */
export const ReportTable = props => {
  const { headers, rows, white, loading } = props;

  const classes = cx('report-table', { 'report-table--white': white });

  const headerRef = useRef(null);
  const bodyRef = useRef(null);

  /*
   * Following code addresses the requirement stated in the MBRD-627 https://isaca-jira.atlassian.net/browse/MBRD-627.
   * Ticket aims to remove the vertical scroll from the table and create a sticky header with only horizontal scroll.
   * Since these requirements exceed the limitations of CSS,
   * the handleTableBodyScroll function has been used to handle the sticky header scrolling functionality.
   * For additional context, please refer to the related GitHub issue: https://github.com/w3c/csswg-drafts/issues/865
   */
  const handleTableBodyScroll = () => {
    headerRef.current.scrollTo({
      left: bodyRef.current.scrollLeft
    });
  };

  return (
    <SkeletonWrapper show={loading} inheritParentSize inheritChildHeight>
      <div className='table-sticky-header' role='header'>
        <div className='report-table__wrapper' ref={headerRef}>
          <table className={classes}>
            <thead>{headers}</thead>
          </table>
        </div>
      </div>
      <div className='report-table-body'>
        <div
          ref={bodyRef}
          className='report-table__wrapper collapsed-header'
          onScroll={handleTableBodyScroll}>
          <table className={classes}>
            <thead>{headers}</thead>
            <tbody>{rows}</tbody>
          </table>
        </div>
      </div>
    </SkeletonWrapper>
  );
};
